import { render } from "./NoTransactions.vue?vue&type=template&id=5a0967b7&ts=true"
import script from "./NoTransactions.vue?vue&type=script&lang=ts"
export * from "./NoTransactions.vue?vue&type=script&lang=ts"

import "./NoTransactions.vue?vue&type=style&index=0&id=5a0967b7&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/transaction/NoTransactions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a0967b7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a0967b7', __exports__)) {
    api.reload('5a0967b7', __exports__)
  }
  
  module.hot.accept("./NoTransactions.vue?vue&type=template&id=5a0967b7&ts=true", () => {
    api.rerender('5a0967b7', render)
  })

}


export default __exports__